module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_01-About_active.33783a31.png";